import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PREVIEW_MODE_KEY, DEMO_ADDRESSES_KEY } from 'src/shared/services/demo-data.service';

import { TidyUiComponentsModule } from 'src/tidy-ui-components/tidy-ui-components.module';

/**
 * Small fixed badge shown for the lifetime of an offline preview session
 * (see DemoPreviewPage), so a product owner clicking through the mock
 * long-term-rental UI always has a way to tell they're in preview and a way
 * out. Renders itself — callers just place it and it self-gates on the flag.
 */
@Component({
  selector: 'app-preview-ribbon',
  templateUrl: './preview-ribbon.component.html',
  styleUrls: ['./preview-ribbon.component.scss'],
  standalone: true,
  imports: [CommonModule, TidyUiComponentsModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PreviewRibbonComponent {

  // Read once at construction, not a template-bound method call — the flag
  // only ever changes via exitPreview(), which navigates away immediately.
  readonly isPreviewMode: boolean = localStorage.getItem(PREVIEW_MODE_KEY) === 'true';

  exitPreview = (): void => {
    localStorage.removeItem(PREVIEW_MODE_KEY);
    localStorage.removeItem(DEMO_ADDRESSES_KEY);
    localStorage.removeItem('tidy_token');
    localStorage.removeItem('tidy_token_type');
    localStorage.removeItem('customer_id');
    localStorage.removeItem('isRentalClient');
    localStorage.removeItem('guest_view_type');
    localStorage.removeItem('email');
    localStorage.removeItem('firstName');
    localStorage.removeItem('lastName');
    localStorage.removeItem('accountType');
    window.location.href = '/overview';
  };
}
